<style >
#dropzone {
  background-color: orange;
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  padding: 0px;
}
.dropzone .dz-message{
  margin:0px!important;
  margin-top:10px!important;
}
.dropzone{
  min-height: 90px;
}
#dropzone .dz-preview {
  width: 160px;
  display: inline-block
}
#dropzone .dz-preview .dz-image {
  width: 80px;
  height: 80px;
  margin-left: 40px;
  margin-bottom: 10px;
}
.vue-dropzone > .dz-preview .dz-details{
  border-radius:0px!important;
  background-color: none !important;
}
</style>
<script>
import vue2Dropzone from "vue2-dropzone";
import documentModal from "./widgets/document_modal.vue"
import { notify } from '@/helpers/notify' 

export default {
  watch:{
    '$route': {
      handler: function() {
        this.loadItems()
      },
      deep: true,
      immediate: true
    },
  },
  components: { 
    vueDropzone: vue2Dropzone,
    documentModal  
  },
  data() {
    return {
      form:{
        type:'0'
      },
      document_data : {},
      subscriber_id: this.$route.params.id,
      rows:[],
      dropzoneOptions: {
        autoProcessQueue: false,
        maxFilesize: 4096,
        thumbnailWidth: 200,
        url: process.env.VUE_APP_URL +  `api/members/${this.$route.params.id}/documents/store`,
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        maxFiles:3,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        },
        dictDefaultMessage:
          "<i class='fas fa-cloud-upload-alt'></i><br/>Dosyayı Buraya Sürükleyiniz" 
      }
    };
  },
  methods: {
    triggerSend() {
      if(this.form.type < 1) return 
        this.$refs.myVueDropzone.processQueue();
    },
    showSuccess(){
      notify.success('Başarılı yüklendi.') 
      this.loadItems()

    },
    sendingEvent(file, xhr, formData) {
      formData.append("type", this.form.type);
    },
    loadItems() {
      const url = `members/${this.subscriber_id}/documents`
      this.$http.post(url)
          .then((response) => {
            this.rows = response.data.content
          });
    },
    show({id,type_name}){
      const url = `members/${this.subscriber_id}/documents/${id}`
      this.$http.get(url)
          .then((response) => {
            const src = `data:${response.data.extension};base64,${response.data.base64}`
            this.document_data = { src,title:type_name }
            this.$bvModal.show('document_modal')
          });
    },
    destroy({id}){
       const url = `members/${this.subscriber_id}/documents/${id}`
       this.$http.delete(url)
          .then(() => {
            notify.success('Başarılı silindi.') 
            this.loadItems()
          });
    }
  },
};
</script>

<template>
<div class="col-md-12">
  <document-modal :data="document_data"/>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-12">
          <select v-model="form.type" class="form-control form-select">
               <option value="0">Belge Tipi Seçiniz</option>
                <option value="20">ABONE SÖZLEŞMESİ ve KİMLİK</option>
                <option value="2">Sözleşme</option>
                <option value="1">Kimlik</option>
                <option value="6">Tahhüt Sözleşmesi</option>
                <option value="5">Vergi Levhası</option>
                <option value="3">Vekalet</option>
                <option value="4">İmza Sirküleri</option>
                <option value="7">Ticaret Sicil Tastiknamesi</option>
                <option value="8">Abonelik İptal Formları</option>
                <option value="9">Taşıma Formları</option>
                <option value="10">Engelli Durum Evrağı</option>
                <option value="11">İkametgah/Yerleşim Belgesi</option>
                <option value="12">İndirim Taahutnamesi</option>
                <option value="13">Abonelik Sözleşmesi</option>
                <option value="14">Cihaz Taahutnamesi</option>
                <option value="15">Kredi Kartı Sözleşmesi</option>
                <option value="16">Öğrenci Belgesi</option>
                <option value="17">Memur Kimliği</option>
                <option value="18">SGK Hizmet Dökümü</option>
                <option value="19">KVKK Onay Formu</option>
                <option value="21">Tarife Değişiklik Formu </option>
                <option value="22">Statik IP Talep Formu</option>
                <option value="23">Karar Defteri</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
         <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            @vdropzone-complete="showSuccess"
            :options="dropzoneOptions"
            v-on:vdropzone-sending="sendingEvent"> <div class="dropzone-custom-content">
              <i class="text-muted bx bxs-cloud-upload"></i>
              <h4>Dosyaları Sürekleyip Bırakabilirisiniz.</h4>
            </div></vue-dropzone>
            <button class="mt-3 btn btn-info" @click="triggerSend()">Yükle</button>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Evrak Tipi</th>
                  <th>Ekleyen</th>
                  <th>Eklenme Tar.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="rows.length == 0">
                  <td colspan="3" class="text-center">Sonuç Bulunmamaktadır</td>
                </tr>
                <tr v-else v-for="row in rows" :key="row.id">
                  <td scope="row">{{ row.type_name }}</td>
                  <td>{{ row.user_name }}</td>
                  <td>{{ formatDate(row.created_at,"DD.MM.YYYY HH:mm") }}</td>
                  <td>
                    <ul class="list-inline font-size-20 contact-links mb-0 text-center">
                        <li class="list-inline-item">
                          <a v-b-tooltip.hover title="Görüntüle" placement="auto" @click="show(row)">
                            <i class="mdi mdi-note-search-outline"></i>
                          </a>
                        </li> 
                        <li class="list-inline-item">
                          <a v-b-tooltip.hover title="Sil" placement="auto" @click="destroy(row)">
                            <i class="mdi mdi-trash-can-outline text-danger"></i>
                          </a>
                        </li>
                      </ul>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>